import React, {ReactElement} from 'react';

import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Line
} from 'recharts';
import numeral from 'numeral';
import Spinner from '../Spinner';
import TableEmptyState from './TableEmptyState';

type SalesByGraphProps = {
  chartStyles: any;
  data: Array<any>;
  loading: boolean;
  height?: string;
};

const SalesByGraph = ({
  height = '100%',
  chartStyles,
  data,
  loading
}: SalesByGraphProps): ReactElement => {
  const renderTableContents = () => {
    if (loading) {
      return <Spinner />;
    }
    if (!data?.length) {
      return <TableEmptyState />;
    }
    return (
      <ResponsiveContainer width="99%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="date" minTickGap={8} />
          <YAxis
            dataKey="sales"
            tickFormatter={tick => `${numeral(tick).format('$0,0')}`}
            axisLine={false}
            tickLine={false}
            width={40}
          />
          <Tooltip
            animationDuration={chartStyles.animationDuration}
            formatter={(value: string) => numeral(value).format('$0,0.00')}
          />
          <Line
            animationDuration={chartStyles.animationDuration}
            dot={false}
            type={chartStyles.lineType}
            dataKey="netSales"
            name="Sales"
            stroke="#1e39d2"
            strokeWidth={chartStyles.strokeWidth}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  };

  return (
    <div className="content-card admin--sales" style={{height}}>
      <small>Sales over time</small>
      <div className="center-content">{renderTableContents()}</div>
    </div>
  );
};

SalesByGraph.defaultProps = {
  height: '100%s'
};

export default SalesByGraph;
